import { FC } from 'react';
import { navigate } from 'gatsby';
import { FormikHelpers } from 'formik';
import { ButtonPrimary, Form, InputText } from '@lambdacurry/component-library';
import { Card, CardContent } from 'lib/components';
import { RegistrationStep } from '../../store';
import { GettingStartedContent, GettingStartedLayout } from '../../components';

interface EmailForm {
  email: string;
}

interface UnsupportedPostalCodePageProps {
  location?: { state: { postal_code: string } };
}

interface UnsupportedPostalCodeProps {
  postal_code: string;
}

const UnsupportedPostalCode: FC<UnsupportedPostalCodeProps> = () => {
  const initialValues: EmailForm = {
    email: ''
  };

  const onSubmit = (values: EmailForm, formikHelpers: FormikHelpers<EmailForm>) => {
    formikHelpers.setSubmitting(true);
    // TODO: Send this information to hubspot.
    console.log('captured email', values.email);
  };

  return (
    <GettingStartedLayout step={RegistrationStep.unsupportedPostalCode} className="registration-index">
      <GettingStartedContent>
        <Card>
          <CardContent>
            <h2>Sorry, We're Not Shipping To Your Area Yet.</h2>
            <p>We can let you know as soon as you we can deliver to your ZIP code.</p>
            <Form enableReinitialize initialValues={initialValues} onSubmit={onSubmit}>
              {formikProps => (
                <>
                  <div className="md:max-w-sm">
                    <InputText label="Email" type="email" name="email" />
                  </div>
                  <ButtonPrimary className="w-full md:w-56" type="submit" disabled={formikProps.isSubmitting}>
                    Subscribe
                  </ButtonPrimary>
                </>
              )}
            </Form>
          </CardContent>
        </Card>
      </GettingStartedContent>
    </GettingStartedLayout>
  );
};

const UnsupportedPostalCodePage: FC<UnsupportedPostalCodePageProps> = ({ location }) => {
  const postal_code = location?.state?.postal_code;
  if (!postal_code && typeof window !== `undefined`) {
    navigate('/getting-started');
    return null;
  }
  return <UnsupportedPostalCode postal_code={postal_code} />;
};

export default UnsupportedPostalCodePage;
